import PropTypes from 'prop-types';
import { React } from 'react';
import Editor from '../../../../../reusable-components/editor/Editor';
import { ticketMessageInput } from './ticket-message-input-cleanup';
import TicketAttachmentThumbnailStack from '../TicketAttachmentThumbnailStack';

TicketEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  editorProps: PropTypes.object,
  users: PropTypes.array,
  attachments: PropTypes.array,
  setAttachments: PropTypes.func,
};

export default function TicketEditor({ value, onChange, editorProps, users, attachments, setAttachments }) {
  const handleFileInputChange = (event) => {
    const maxAllowedFiles = 5;
    if (event.target.files.length > maxAllowedFiles || event.target.files.length + attachments?.length > maxAllowedFiles) {
      alert(`Only ${maxAllowedFiles} files can be uploaded at a time.`);
      event.target.value = '';
      return;
    }
    const { files } = event.target;
    const fileList = [];
    for (let i = 0; i < files.length; i++) {
      if (attachments?.some((x) => x.name === files[i].name)) alert(`File ${files[i].name} already exists.`);
      else fileList.push(files[i]);
    }
    setAttachments((prevAttachments) => [...(prevAttachments || []), ...fileList]);
  };

  const handleChangeMessage = async (newValue) => ticketMessageInput(newValue, onChange);

  const attachFile = editorProps?.attachFile ?? true;

  return <>
    <Editor
      simple
      users={users}
      onChange={handleChangeMessage}
      aiHelp
      sx={{ flexGrow: 1, borderColor: 'transparent', width: '100%' }}
      handleFileInputChange={attachFile ? handleFileInputChange : null}
      {...(editorProps || {})}
      attachFile={attachFile}
      value={value || "<p></p>"}
    />
    {attachFile && <TicketAttachmentThumbnailStack attachments={attachments} setAttachments={setAttachments} />}
  </>;
}